'use client';

import { useRouter } from 'next/navigation';
import { ButtonV2 } from '@/app_components/ui/ButtonV2';
import { login } from '@/app_lib/services/tinypass/service';
import { ContentPlacement } from '@/app_lib/types/analytics';

const trackingData = {
  data: {
    // biome-ignore lint/style/useNamingConvention: external data
    contentPlacementCD: 'header',
    eventAction: 'top header links',
    eventCategory: 'navigation',
    eventLabel: 'sign in',
  },
};

export const SignInButton = ({
  className,
  disabled = false,
  isMobile = false,
}: {
  className?: string;
  disabled?: boolean;
  isMobile?: boolean;
}) => {
  const router = useRouter();

  return (
    <ButtonV2
      as='button'
      className={className}
      data-cy={isMobile ? ContentPlacement.SigninButtonMobile : ContentPlacement.SigninButtonDesktop}
      disabled={disabled}
      isTertiary
      onClick={() => login({ onLogin: () => router.refresh() })}
      trackingData={trackingData}
    >
      Sign in
    </ButtonV2>
  );
};
